// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconCopy: React.FC = () => {
    return (<svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13"><path fill="currentColor" d="M9,2.25 L9,0 L6.375,0 C5.753672,0 5.25,0.503671646 5.25,1.125 L5.25,7.875 C5.25,8.49632835 5.753672,9 6.375,9 L10.875,9 C11.4963284,9 12,8.49632835 12,7.875 L12,3 L9.77109361,3 C9.33749986,3 9,2.66250014 9,2.25 Z M9.75,0 L9.75,2.25 L12,2.25 L9.75,0 Z M4.5,8.25 L4.5,3 L1.125,3 C0.503672004,3 0,3.50367165 0,4.125 L0,10.875 C0,11.4963284 0.503672004,12 1.125,12 L5.625,12 C6.24632835,12 6.75,11.4963284 6.75,10.875 L6.75,9.75 L6,9.75 C5.17265618,9.75 4.5,9.07734346 4.5,8.25 Z" transform="translate(0 .5)"/></svg>);
};

export default React.memo(IconCopy);
